import ContentImage from './ContentImage'

const fallbackImages = ['piloteadora-cielo', 'perforacion-nocturna', 'equipo-campo', 'obra-tijuana', 'maquinaria-panoramica']
const fallbackForSlug = (slug) => fallbackImages[Math.abs(slug.length) % fallbackImages.length]

const formatDate = (value) => value
  ? new Intl.DateTimeFormat('es-MX', { day: '2-digit', month: 'long', year: 'numeric' }).format(new Date(value))
  : 'Archivo CRS'

const isHeading = (text) => text.length < 82 && (
  !/[.!?]$/.test(text) || /^(participación|introducción|conclusión|descripción|ventajas|importancia|beneficios|impacto|relaciones|proceso)/i.test(text)
)

export default function ArticlePage({ entry, related }) {
  const fallback = fallbackForSlug(entry.slug)
  const minutes = Math.max(2, Math.ceil(entry.textBlocks.join(' ').split(/\s+/).length / 210))
  const categoryPath = entry.category === 'Info técnica' ? '/category/info-tecnica/' : entry.category === 'Video' ? '/category/video/' : '/category/noticias/'

  return (
    <>
      <article className="article-page">
        <header className="article-hero texture-grid">
          <div className="article-hero-copy">
            <nav className="breadcrumbs" aria-label="Migas de pan"><a href="/">Inicio</a><span>/</span><a href="/noticias/">Noticias</a><span>/</span><a href={categoryPath}>{entry.category}</a><span>/</span><span aria-current="page">{entry.title}</span></nav>
            <p className="eyebrow light">{entry.category}</p>
            <h1>{entry.title}</h1>
            <p className="article-deck">{entry.description}</p>
            <div className="article-meta"><span>{formatDate(entry.publishedAt)}</span><span>{minutes} min de lectura</span><span>Archivo CRS</span></div>
          </div>
          <ContentImage image={entry.images[0]} fallback={fallback} alt={entry.images[0]?.alt || entry.title} className="article-hero-image" sizes="(min-width: 900px) 48vw, 100vw" eager />
        </header>

        <div className="article-layout">
          <aside className="article-aside">
            <span className="article-folio">CRS / {entry.category}</span>
            <p>Contenido migrado y revisado desde el archivo público de CRS Cimentaciones.</p>
            <a href="/contacto/" data-analytics-event="cta_click" data-analytics-location="article_aside" data-analytics-label="Consultar un proyecto">Consultar un proyecto ↗</a>
          </aside>
          <div className="article-body">
            {entry.textBlocks.map((block, index) => isHeading(block)
              ? <h2 key={`${block}-${index}`}>{block}</h2>
              : <p className={index === 0 ? 'article-lead' : ''} key={`${block.slice(0, 28)}-${index}`}>{block}</p>)}
          </div>
        </div>

        {entry.images.length > 1 && (
          <section className="article-gallery" aria-label={`Galería de ${entry.title}`}>
            {entry.images.slice(1, 7).map((image, index) => <figure key={image.key} data-reveal><ContentImage image={image} alt={image.alt} sizes="(min-width: 900px) 50vw, 100vw" /><figcaption>CRS / Registro {String(index + 1).padStart(2, '0')}</figcaption></figure>)}
          </section>
        )}

        <section className="related-section texture-grid">
          <div className="related-heading"><p className="eyebrow">Continuar explorando</p><h2>Más del archivo CRS.</h2></div>
          <div className="related-grid">
            {related.map((item) => (
              <a href={item.path} key={item.slug} data-analytics-event="select_content" data-analytics-location="related_content" data-analytics-content-type="article" data-analytics-content-id={item.slug} data-analytics-label={item.title}>
                <ContentImage image={item.images[0]} fallback={fallbackForSlug(item.slug)} alt={item.images[0]?.alt || `${item.title}: archivo visual de CRS Cimentaciones`} className="related-card-image" sizes="(min-width: 900px) 33vw, 100vw" />
                <div className="related-card-copy"><span>{item.category}</span><h3>{item.title}</h3><i>↗</i></div>
              </a>
            ))}
          </div>
        </section>
      </article>
    </>
  )
}
